class NumericRange {
  /**
   * Create numeric range
   * @param {HTMLElement} container Containing element
   */
  constructor (container) {
    this.formSubmitButton = document.querySelector('#license-submit')
    /** @type {HTMLDivElement} */
    this.warning = container.querySelector('.js-numeric-range-warning')
    /** @type {HTMLDivElement} */
    this.error = container.querySelector('.js-numeric-range-error')

    /** @type {HTMLDivElement} */
    this.warningMin = container.querySelector('.js-numeric-range-warning-min')
    /** @type {HTMLDivElement} */
    this.errorMin = container.querySelector('.js-numeric-range-error-min')

    /** @type {HTMLInputElement} */
    this.input = container.querySelector('.js-numeric-range-input')

    this.warningThreshold = parseInt(container.dataset.warningThreshold)
    this.errorThreshold = parseInt(container.dataset.errorThreshold)

    this.warningThresholdMin = parseInt(container.dataset.warningThresholdMin) || 0
    this.errorThresholdMin = parseInt(container.dataset.errorThresholdMin) || 0
  }

  init () {
    this.input.addEventListener('change', () => this.checkRange())

    this.checkRange()
  }

  get value () {
    return this.input.value
  }

  checkRange () {
    const value = this.value

    if (!value) {
      return
    }

    if (value <= this.errorThresholdMin) {
      this.hideAll()
      this.showErrorMin()
      this.disableSubmitButton()
      return
    } else if (value <= this.warningThresholdMin) {
      this.hideAll()
      this.showWarningMin()
      this.enableSubmitButton()
      return
    } else {
      this.hideAll()
      this.enableSubmitButton()
    }

    if (value >= this.errorThreshold) {
      this.hideAll()
      this.showError()
      this.disableSubmitButton()
      return
    } else if (value >= this.warningThreshold) {
      this.hideAll()
      this.showWarning()
      this.enableSubmitButton()
      return
    }

    this.hideAll()
    this.enableSubmitButton()
  }

  hideAll () {
    this.hideWarning()
    this.hideError()
    this.hideWarningMin()
    this.hideErrorMin()
  }

  showWarningMin () {
    if (this.warningMin) {
      this.warningMin.hidden = false
    }
  }

  showWarning () {
    if (this.warning) {
      this.warning.hidden = false
    }
  }

  showErrorMin () {
    if (this.errorMin) {
      this.errorMin.hidden = false
    }
  }

  showError () {
    if (this.error) {
      this.error.hidden = false
    }
  }

  hideWarning () {
    if (this.warning) {
      this.warning.hidden = true
    }
  }

  hideWarningMin () {
    if (this.warningMin) {
      this.warningMin.hidden = true
    }
  }

  hideError () {
    if (this.error) {
      this.error.hidden = true
    }
  }

  hideErrorMin () {
    if (this.errorMin) {
      this.errorMin.hidden = true
    }
  }

  enableSubmitButton () {
    const validationErrors = document.querySelectorAll('.notification--error:not([hidden])')
    if (validationErrors.length) {
      return
    }

    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'false'
      this.formSubmitButton.removeAttribute('disabled')
    }
  }

  disableSubmitButton () {
    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'true'
      this.formSubmitButton.setAttribute('disabled', '')
    }
  }
}

const ranges = document.querySelectorAll('.js-numeric-range')
ranges.forEach(range => new NumericRange(range).init())
